import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

/**
 * Calls onBack once when currently managed entity changes after mount.
 */
export default function useAutoBackOnManagingChange({
    enabled = true,
    onBack,
}) {
    const { currentCompany, currentPartner, currentWholesaler } = useSelector(
        (state) => state.navigationLists,
    );

    const initialManagingRef = useRef({
        currentCompany,
        currentPartner,
        currentWholesaler,
    });
    const hasTriggeredRef = useRef(false);

    useEffect(() => {
        if (!enabled || hasTriggeredRef.current || typeof onBack !== 'function') {
            return;
        }

        const hasManagingChanged =
            initialManagingRef.current.currentCompany !== currentCompany ||
            initialManagingRef.current.currentPartner !== currentPartner ||
            initialManagingRef.current.currentWholesaler !== currentWholesaler;

        if (!hasManagingChanged) {
            return;
        }

        hasTriggeredRef.current = true;
        onBack();
    }, [enabled, onBack, currentCompany, currentPartner, currentWholesaler]);
}
